import axios from 'axios'
import store from '@/store'
import Constants from '@/mixin/global/constants.js'
import { Message } from 'element-ui'

const http = axios.create({
  baseURL: Constants.API_URL
})

http.interceptors.request.use((config) => {
  console.log(config.url)
  console.log(config.data)
  return config
})

http.interceptors.response.use(function (response) {
  console.log(response.data)
  return response.data
}, function (error) {
  console.log(error.response)
  if (error.response.status === 401) {
    if (error.response.statusText.indexOf('timeout') > -1) {
      Message({
        type: 'info',
        message: Constants.MESSAGE.TIMEOUT,
        duration: 5000
      })
    }
    store.dispatch('User/logout')
  }
  return error
})

export default http



// WEBPACK FOOTER //
// ./src/http/index.js